// Helper function to evaluate `visibleIf`
const evaluateVisibleIf = (visibleIf, fieldValues, contentType) => {
  if (!visibleIf) return true

  // NEW: Support function-based visibleIf for complex conditions
  if (typeof visibleIf === 'function') {
    try {
      return visibleIf(fieldValues)
    } catch (error) {
      console.error('Error evaluating visibleIf function:', error)
      return false
    }
  }

  // EXISTING: Object-based visibleIf with operators (eq, ne, in, nin)
  const result = Object.entries(visibleIf).every(([fieldID, condition]) => {
    let fieldValue = fieldValues[fieldID]

    // If the field value is undefined/null, check if the field has a default value
    if (fieldValue === undefined || fieldValue === null) {
      const field = contentType?.fields?.find(f => f.id === fieldID)
      if (field && field.default !== undefined) {
        fieldValue = field.default
      }
    }

    const values = Array.isArray(fieldValue) ? fieldValue : [fieldValue]

    for (const item of values) {
      let value = item
      if (typeof item === "object" && item.value !== undefined) {
        value = item.value
      }

      if (condition.eq !== undefined) {
        return condition.eq === value
      }
      if (condition.ne !== undefined) {
        return condition.ne !== value
      }
      if (condition.in && Array.isArray(condition.in)) {
        return condition.in.includes(value)
      }
      if (condition.nin && Array.isArray(condition.nin)) {
        return !condition.nin.includes(value)
      }
    }
    return true
  })

  return result
}

export default evaluateVisibleIf